import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Modal } from "@ts-digital/vrc";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import NumberFormat from "react-number-format";
import moment from "moment";

import "./style.css";

const CashFlowModal = ({ isModalVisible, setModalVisible, setGraph, isTsPayEnabled, setShowPlaceholder }) => {
  const navigate = useNavigate();
  const tspay = useSelector(state => state.tspay);
  const tspayAccounts = tspay.accounts.list;
  const main = useSelector(state => state.main);
  const [totalCurrentBalance, setTotalCurrentBalance] = useState(0);
  const [totalCashModal, setTotalCashModal] = useState(0);
  const [disableRegister, setDisableRegister] = useState(false);
  const [configStatus, setConfigStatus] = useState("");

  useEffect(() => {
    setConfigStatus(tspay?.configStatus?.data?.status);
  }, [tspay]);

  useEffect(() => {
    const objList = JSON.parse(localStorage.getItem("objCashFlow"));
    const objCompany = objList?.filter(el => el.id === main.companyUuidSelected);

    if (objCompany?.length > 0 && objCompany[0]?.available) {
      setTotalCashModal(parseFloat(objCompany[0].available));
    }
    if (objCompany?.length > 0 && objCompany[0]?.balance) {
      setTotalCurrentBalance(parseFloat(objCompany[0].balance));
    }
  }, []);

  useEffect(() => {
    if (((main.myType !== "STUDIO" && isTsPayEnabled) || (main.myType === "STUDIO")) && tspayAccounts) {
      let total = 0;
      tspayAccounts.map(account => {
        if (account.amount) {
          total += account.amount;
        }
        return null;
      });
      setTotalCurrentBalance(total);
    }
  }, [tspayAccounts]);

  useEffect(() => {
    if (totalCurrentBalance === 0 || !totalCurrentBalance) {
      setDisableRegister(true);
    } else setDisableRegister(false);
  }, [totalCurrentBalance]);

  const onSave = () => {
    const balance =
      parseFloat(totalCurrentBalance) + parseFloat(totalCashModal);

    const objList = JSON.parse(localStorage.getItem("objCashFlow"));
    const objCompany = objList.filter(el => el.id === main.companyUuidSelected);

    if (objCompany.length === 0) {
      if (((main.myType !== "STUDIO" && isTsPayEnabled) || (main.myType === "STUDIO"))){
        objList.push({
          id: main.companyUuidSelected,
          available: totalCashModal,
          lastUpdate: moment()
        });
      } else {
        objList.push({
          id: main.companyUuidSelected,
          balance: totalCurrentBalance,
          available: totalCashModal,
          lastUpdate: moment()
        });
      }
    } else {
      const objIndex = objList.findIndex(obj => obj.id === main.companyUuidSelected);
      objList[objIndex].available = totalCashModal;
      objList[objIndex].lastUpdate = moment();
      if (!isTsPayEnabled){
        objList[objIndex].balance = totalCurrentBalance;
      }
    }
    localStorage.setItem("objCashFlow", JSON.stringify(objList));
    setModalVisible(false);
    setShowPlaceholder(false);
    setGraph({ display: true, balance: balance });
  };

  const navigateToTsPayLanding = () => {
    if (main.myType === "STUDIO"){
      navigate("/landing-no-tspay");      
    } else {
      navigate("/tspay-onboarding");      
    }
  };

  return (
    <Modal
      title={<FormattedMessage id="analytics.cashFlowModalTitle" />}
      visible={isModalVisible}
      onClose={() => {
        setModalVisible(false);
      }}
      type="primary"
      footer={
        <div className="cashFlowModal-footer">
          <Button
            kind="secondary"
            onClick={() => setModalVisible(false)}
            size="medium"
          >
            <FormattedMessage id="actions.cancel" />
          </Button>
          <Button
            disabled={disableRegister}
            onClick={() => onSave()}
            size="medium"
          >
            <FormattedMessage id="analytics.viewCashFlow" />
          </Button>
        </div>
      }
    >
      <div style={{ width: "581px" }}>
        <div className="cashFlowContent">
          <FormattedMessage id="analytics.cashFlowContent" />
        </div>
        <div
          className={
            "cashFlowModalForm" +
            (configStatus === "LINKED"
              ? " fullWidth"
              : "")
          }
          style={{ marginTop: "30px" }}
        >
          <div className="subCashFlow">
            <FormattedMessage id="analytics.currentAccountBalance" />
          </div>
          <div className="miniTextContainer">
            <div className="numberStyle" style={{ flex: "1 1 auto" }}>
              <NumberFormat
                className={
                  disableRegister ? "numberStyle errorEmpty" : "numberStyle"
                }
                allowLeadingZeros={true}
                displayType={"input"}
                placeholder={"0 €"}
                suffix={" €"}
                thousandSeparator={"."}
                decimalSeparator={","}                
                value={totalCurrentBalance ? numeral(totalCurrentBalance).format("0,0.00") : null}
                disabled={
                  tspayAccounts && tspayAccounts.length > 0 ? true : false
                }
                onValueChange={el => {
                  if (parseFloat(el.value) === 0 || el.value === "") {
                    setDisableRegister(true);
                  } else {
                    setTotalCurrentBalance(parseFloat(el.value));
                  }
                }}
              />
            </div>
            {configStatus === "NOT_LINKED" ? (
              <div className="txtFlex">
                <div className="txtTsPay">
                  <FormattedMessage id="analytics.or" />
                </div>
                <div style={{ margin: "0 15px" }} className="txtTsPay tsColor" onClick={() => navigateToTsPayLanding()}>
                  <FormattedMessage id="analytics.findOutTsPay" />
                </div>
              </div>
            ) : null}
          </div>
          {disableRegister && (
            <span className="deadlines-registerPaymentAmountZero">
              <FormattedMessage id="deadlines.pages.detail.registerPaymentDifferentToZero" />
            </span>
          )}

          <div className="subCashFlow">
            <FormattedMessage id="analytics.cashAndCashEquivalents" />
          </div>
          <div className="miniTextContainer">
            <div className="numberStyle">
              <NumberFormat
                className="numberStyle"
                allowLeadingZeros={true}
                displayType={"input"}
                placeholder={"0 €"}
                suffix={" €"}
                thousandSeparator={"."}
                decimalSeparator={","}                
                value={totalCashModal ? numeral(totalCashModal).format("0,0.00") : null}
                onValueChange={el => {
                  setTotalCashModal(parseFloat(el.value));
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CashFlowModal;
